import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=6a441aa1&scoped=true&"
import script from "./Deliveries.vue?vue&type=script&lang=js&"
export * from "./Deliveries.vue?vue&type=script&lang=js&"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=6a441aa1&prod&lang=css&"
import style1 from "./Deliveries.vue?vue&type=style&index=1&id=6a441aa1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a441aa1",
  null
  
)

export default component.exports